import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Translate from '@securitize/ui-components/i18n/Translate';
import { Card, Col } from 'reactstrap';
import pendingImage from '../../../../../../../assets/img/other/pending.svg';
import './PendingInvestment.scss';
import CustomCircleProgressBar from '../../../CustomCircleProgressBar';
import FundingInstructions from '../FundingInstructions';

const PendingInvestment = ({ pageNumber, totalSteps, additionalAccreditation }) => {
  const { user } = useSelector((state) => ({
    user: state.auth.user,
  }));
  const isNotAccredited = Boolean(additionalAccreditation) && user.accreditedStatus !== 'confirmed';

  return (
    <>
      <Col className="d-flex align-items-center p-0 mb-4">
        <CustomCircleProgressBar currentValue={pageNumber} totalItems={totalSteps} />
        <h1 className="font-32 font-weight-semi mb-0">
          {`0${pageNumber}. `}
          <Translate translationKey="Texts.payment-pending-verification" />
        </h1>
      </Col>
      { isNotAccredited && <FundingInstructions /> }
      <Card className="pending-invest-card border-0 box-shadow">
        <Col className="pending-invest-card__col">
          <h1 className="pending-invest-card__col__header m-0 font-20">
            <i className="icon-clock mr-md-3 mr-2" />
            <Translate translationKey="Texts.verify-investment" />
          </h1>
          <div className="pending-invest-card__image mt-4">
            <img src={pendingImage} className="w-100" alt="pendingImage" />
          </div>
          <p className="m-0 font-16 mt-3 text-muted pending-invest-card__description">
            <Translate translationKey="Texts.verify-investment-description" />
          </p>
        </Col>
      </Card>
    </>
  );
};

PendingInvestment.propTypes = {
  pageNumber: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  additionalAccreditation: PropTypes.bool.isRequired,
};

export default PendingInvestment;
